var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-main",
    { attrs: { "grid-list-xl": "", fluid: "" } },
    [
      _c(
        "v-layout",
        _vm._b({}, "v-layout", _vm.binding, false),
        _vm._l(_vm.task, function(content) {
          return _c(
            "v-flex",
            { key: content.id, staticClass: "mt-4", attrs: { xs6: "" } },
            [
              _c(
                "v-card",
                {
                  staticClass: "pa-2 image-effect",
                  attrs: { width: "200px", loading: "" },
                  on: {
                    click: function($event) {
                      return _vm.openImageView(content)
                    }
                  }
                },
                [
                  content.value
                    ? _c("v-img", {
                        attrs: {
                          src: content.value,
                          height: "200px",
                          contain: "",
                          loading: "",
                          "lazy-src": content.value
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-card-title", [
                    _vm._v(
                      "\n          " + _vm._s(content.label) + "\n        "
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm.imageData
                ? _c("photo-view", {
                    attrs: { dialog: _vm.dialog, imageData: _vm.imageData },
                    on: {
                      close: function($event) {
                        return _vm.closeImageView($event)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6eacf99e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eacf99e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Activities/TaskTypes/Photos/PhotoViewEditDialog.vue
// module id = null
// module chunks = 